var render = function (_h,_vm) {var _c=_vm._c;return _c('i',{class:['icons', 'base-icons', ("icons-" + (_vm.props.iconName)), _vm.data.staticClass],style:({fontSize: _vm.props.iconSize, color: _vm.props.iconColor})})}
var staticRenderFns = []

export { render, staticRenderFns }